import { PlatzApiError } from "../api-generated";

export function getPlatzApiError(error: any): PlatzApiError | undefined {
  if (error === null || error === undefined) {
    return error;
  }
  if (error.isAxiosError) {
    return error.response.data;
  }
  return undefined;
}
